import React from 'react';
import { PricingCards } from './PricingSection';
export function FinalCTA() {
  return <section className="py-10 sm:py-16 bg-[#0a0a0a] text-center" data-id="element-44">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-45">
        <h2 className="text-xl sm:text-3xl md:text-4xl font-black text-white mb-3 sm:mb-4 uppercase tracking-tight" data-id="element-46">
          ¿LISTO/A PARA DEJAR DE IMPROVISAR?
        </h2>

        <p className="text-sm sm:text-lg md:text-xl text-gray-300 mb-8 sm:mb-10 font-medium" data-id="element-47">
          Sumate a docentes que ya tienen su año resuelto.
        </p>

        <PricingCards showExtras={false} data-id="element-48" />
      </div>
    </section>;
}